<template>
  <b-card>
    <div style="font-size: 12px">
      <div class="title">
        <span>Cadastro de Cliente</span>
        <span class="requiredFields">* Campos Obrigatórios</span>
      </div>
      <div class="carroselCtn">
        <div class="StatementOnAccount">
          <label
            v-for="item in tabs"
            :key="item.text"
            class="StatementOnAccountItem"
            :class="{
              active: selectedLabel === item.value,
              tabDisabled: !dataCostumer.id,
            }"
            @click="storeLabelName(item.text)"
          >
            {{ item.text }} <br />
          </label>
        </div>
      </div>
      <div
        v-if="selectedLabel === 'Informações Gerais'"
        style="display: flex; flex-direction: column"
      >
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Informações
            Gerais</span
          >
          <div class="rowContent">
            <b-form-input
              hidden
              class="col-sm-1"
              v-model="dataCostumer.id"
            ></b-form-input>
            <div class="input-group">
              <input
                required
                :class="`input borderInput ${
                  invalidFields?.nome && 'isInvalidInput'
                }`"
                v-model="dataCostumer.nome"
                @blur="clearInvalidFields('nome')"
                @input="clearInvalidFields('nome')"
              />
              <label
                :class="`user-label ${invalidFields?.nome && 'invalidLabel'}`"
              >
                Nome <span class="validRed">*</span>
              </label>
            </div>
            <div class="input-group">
              <input
                required
                :class="`input borderInput ${
                  invalidFields?.cpfCnpj && 'isInvalidInput'
                }`"
                v-model="dataCostumer.cpfCnpj"
                v-mask="maskCpfCnpj(dataCostumer.cpfCnpj)"
                maxlength="18"
                @input="checkInputLength"
                @blur="clearInvalidFields('cpfCnpj')"
              />
              <label
                :class="`user-label ${
                  invalidFields?.cpfCnpj && 'invalidLabel'
                }`"
              >
                CPF/CNPJ <span class="validRed">*</span>
              </label>
              <button
                class="bcsCep"
                v-if="isInputLengthValid"
                @click="fetchCnpj(dataCostumer.cpfCnpj)"
              >
                <b-spinner
                  v-if="spinGeneralCnpj"
                  small
                  label="Small Spinner"
                ></b-spinner>
                buscar
              </button>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.ie"
              />
              <label class="user-label"> Inscrição Estadual </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.rg"
              />
              <label class="user-label"> Registro Geral </label>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span> <b-icon-geo-alt-fill></b-icon-geo-alt-fill> Localização</span>
          <div class="rowContent">
            <div class="input-group">
              <input
                required
                :class="`input borderInput ${
                  invalidFields?.cep && 'isInvalidInput'
                }`"
                v-model="dataCostumer.cep"
                @blur="clearInvalidFields('cep')"
                @input="clearInvalidFields('cep')"
                v-mask="maskCep"
              />
              <label
                :class="`user-label ${invalidFields?.cep && 'invalidLabel'}`"
              >
                CEP <span class="validRed">*</span>
              </label>
              <button class="bcsCep" @click="fetchCep(dataCostumer.cep)">
                <b-spinner
                  v-if="spinGeneral"
                  small
                  label="Small Spinner"
                ></b-spinner>
                buscar
              </button>
            </div>

            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.endereco"
              />
              <label class="user-label"> Endereço </label>
            </div>

            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.bairro"
              />
              <label class="user-label"> Bairro </label>
            </div>

            <div class="input-group">
              <input
                required
                :class="`input borderInput ${
                  invalidFields?.cidade && 'isInvalidInput'
                }`"
                v-model="dataCostumer.cidade"
                @blur="clearInvalidFields('cidade')"
                @input="clearInvalidFields('cidade')"
              />
              <label
                :class="`user-label ${invalidFields?.cidade && 'invalidLabel'}`"
              >
                Cidade <span class="validRed">*</span>
              </label>
            </div>
          </div>

          <div class="rowContent">
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.numero"
              />
              <label class="user-label"> Número </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.complemento"
              />
              <label class="user-label"> Complemento </label>
            </div>

            <div class="selectPlus">
              <label
                :class="`fixedSelect2 ${invalidFields?.uf && 'invalidLabel'}`"
                >UF <span class="validRed">*</span></label
              >
              <b-form-select
                :class="`borderInput shadow-none ${
                  invalidFields?.uf && 'isInvalidInput'
                }`"
                value-field="value"
                text-field="text"
                :options="ufs"
                v-model="dataCostumer.uf"
                @blur.native="clearInvalidFields('uf')"
              >
              </b-form-select>
            </div>

            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.ibge"
              />
              <label class="user-label"> Código IBGE </label>
            </div>
          </div>
          <!-- <div class="rowContent">
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.latitude"
              />
              <label class="user-label"> Latitude : (UTMN) </label>
            </div>

            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.longitude"
              />
              <label class="user-label"> Longitude : (UTME) </label>
            </div>
          </div> -->
        </div>
        <div class="rowContainer">
          <span> <b-icon-telephone-fill></b-icon-telephone-fill> Contatos</span>
          <div class="rowContent">
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-mask="maskTelefone"
                v-model="dataCostumer.telefone"
              />
              <label class="user-label"> Telefone </label>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.celular"
                v-mask="maskCelular"
              />
              <label class="user-label"> Whatsapp </label>
              <div class="iconSelect">
                <div role="button">
                  <img
                    class="whatsapp"
                    :src="whatsapp"
                    @click="redirectWhatsApp(dataCostumer.celular)"
                  />
                </div>
              </div>
            </div>
            <div class="input-group">
              <input
                required
                class="input borderInput"
                v-model="dataCostumer.email"
              />
              <label class="user-label"> Email </label>
            </div>
          </div>
        </div>

        <div class="rowContainer" style="margin-bottom: 30px">
          <span>
            <b-icon-info-circle></b-icon-info-circle> Outras Informações</span
          >
          <div>
            <div class="rowContent">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="dataCostumer.dataNascimento"
                />
                <label class="user-label"> Data de Nascimento </label>
              </div>
              <div class="selectPlus">
                <label class="fixedSelect2">Tipo consumidor</label>
                <b-form-select
                  class="borderInput shadow-none"
                  value-field="value"
                  text-field="text"
                  :options="consumidorFinal"
                  v-model="dataCostumer.consumidor_final"
                >
                </b-form-select>
              </div>
              <div class="selectPlus">
                <label class="fixedSelect2">Contribuinte</label>
                <b-form-select
                  class="borderInput shadow-none"
                  value-field="value"
                  text-field="text"
                  :options="contribuinte"
                  v-model="dataCostumer.contribuinte"
                >
                </b-form-select>
              </div>
            </div>
            <div class="rowObservation">
              <div class="input-group-ob">
                <input
                  required
                  class="input borderInput"
                  v-model="dataCostumer.observacao"
                />
                <label class="user-label-ob"> Observações </label>
              </div>
              <div class="selectPlus">
                <label class="fixedSelect2">Status</label>
                <b-form-select
                  class="borderInput shadow-none"
                  value-field="value"
                  text-field="text"
                  :options="status"
                  v-model="dataCostumer.status"
                  :disabled="!this.dataCostumer.id"
                >
                </b-form-select>
              </div>
            </div>
            <div class="btnsContainer">
              <b-button class="btnsSaveNeutral" @click="handleNewCustomer"
                >Novo
                <b-icon-arrow-clockwise class="ml-1"></b-icon-arrow-clockwise
              ></b-button>
              <b-button
                class="btnsSave"
                @click="saveOrUpdateCustomer"
                :disabled="isLoading"
              >
                {{ dataCostumer.id ? "Atualizar" : "Salvar" }}

                <div
                  v-if="isLoading"
                  style="
                    position: absolute;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    top: 0px;
                    right: 20px;
                  "
                >
                  <b-spinner small label="Small Spinner"></b-spinner>
                </div>
                <b-icon-person-check class="ml-1" />
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div v-show="selectedLabel === 'Propriedades'" class="property-tab">
        <b-row class="property-workspace">
          <b-col cols="12" md="6" lg="6" class="mb-3 mb-md-0">
            <section class="property-form-panel">
              <div class="property-section-title">
                <b-icon-geo-alt-fill /> Dados da propriedade
              </div>

              <b-row>
                <div class="rowContainer" style="width: 100%; gap: 10px">
                  <div class="rowContent" style="flex-direction: column">
                    <div style="display: flex; gap: 10px">
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          :class="`input borderInput ${
                            invalidFieldsProperty?.nome && 'isInvalidInput'
                          }`"
                          v-model="property.nome"
                          @blur="
                            clearInvalidFields('nome', 'invalidFieldsProperty')
                          "
                          @input="
                            clearInvalidFields('nome', 'invalidFieldsProperty')
                          "
                        />
                        <label
                          :class="`user-label ${
                            invalidFieldsProperty?.nome && 'invalidLabel'
                          }`"
                        >
                          Nome da Propriedade <span class="validRed">*</span>
                        </label>
                      </div>
                      <div class="input-group" style="width: 100% !important">
                        <input
                          required
                          :class="`input borderInput`"
                          v-model="property.cpfCnpj"
                          v-mask="maskCpfCnpj(property.cpfCnpj)"
                          @input="checkInputLength"
                        />
                        <label :class="`user-label`"> CPF/CNPJ </label>
                        <button
                          class="bcsCep"
                          v-if="isInputPropertyLengthValid"
                          @click="fetchCnpj(property.cpfCnpj, 'property')"
                        >
                          <b-spinner
                            v-if="spinGeneralCnpj"
                            small
                            label="Small Spinner"
                          ></b-spinner>
                          buscar
                        </button>
                      </div>
                    </div>
                    <div style="display: flex; gap: 10px">
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.ipr"
                        />
                        <label class="user-label"> I.PR</label>
                      </div>
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.ie"
                        />
                        <label class="user-label" style="width: 100%">
                          I.E</label
                        >
                      </div>
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.area"
                        />
                        <label class="user-label"> Área (M²) </label>
                      </div>
                    </div>
                  </div>

                  <div class="rowContent" style="flex-direction: column">
                    <div style="display: flex; gap: 10px">
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          :class="`input borderInput ${
                            invalidFieldsProperty?.cep && 'isInvalidInput'
                          }`"
                          v-model="property.cep"
                          v-mask="maskCep"
                          @blur="
                            clearInvalidFields('cep', 'invalidFieldsProperty')
                          "
                          @input="
                            clearInvalidFields('cep', 'invalidFieldsProperty')
                          "
                        />
                        <label
                          :class="`user-label ${
                            invalidFieldsProperty?.cep && 'invalidLabel'
                          }`"
                        >
                          CEP <span class="validRed">*</span>
                        </label>
                        <button
                          class="bcsCep"
                          @click="fetchCep(property.cep, 'property')"
                        >
                          <b-spinner
                            v-if="spinGeneral"
                            small
                            label="Small Spinner"
                          ></b-spinner>
                          buscar
                        </button>
                      </div>
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.bairro"
                        />
                        <label class="user-label"> Bairro </label>
                      </div>
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          :class="`input borderInput ${
                            invalidFieldsProperty?.cidade && 'isInvalidInput'
                          }`"
                          v-model="property.cidade"
                          @blur="
                            clearInvalidFields(
                              'cidade',
                              'invalidFieldsProperty'
                            )
                          "
                          @input="
                            clearInvalidFields(
                              'cidade',
                              'invalidFieldsProperty'
                            )
                          "
                        />
                        <label
                          :class="`user-label ${
                            invalidFieldsProperty?.cidade && 'invalidLabel'
                          }`"
                        >
                          Cidade <span class="validRed">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="input-group" style="width: 100%">
                      <input
                        required
                        class="input borderInput"
                        v-model="property.endereco"
                      />
                      <label class="user-label"> Endereço </label>
                    </div>
                  </div>

                  <div
                    class="rowContent"
                    style="flex-direction: column; gap: 15px"
                  >
                    <div style="display: flex; gap: 10px">
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.latitude"
                        />
                        <label
                          class="user-label"
                          style="left: 3px; bottom: 7px"
                        >
                          Latitude (UTMN)
                        </label>
                      </div>
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.longitude"
                        />
                        <label
                          class="user-label"
                          style="left: 3px; bottom: 7px"
                        >
                          Longitude (UTME)
                        </label>
                      </div>
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.numero"
                        />
                        <label class="user-label"> Número </label>
                      </div>
                    </div>
                    <div style="display: flex; gap: 10px">
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.complemento"
                        />
                        <label class="user-label"> Complemento </label>
                      </div>
                      <div class="selectPlus" style="width: 100%">
                        <label
                          :class="`fixedSelect2 ${
                            invalidFieldsProperty?.uf && 'invalidLabel'
                          }`"
                          >UF <span class="validRed">*</span></label
                        >
                        <b-form-select
                          :class="`borderInput shadow-none ${
                            invalidFieldsProperty?.uf && 'isInvalidInput'
                          }`"
                          value-field="value"
                          text-field="text"
                          :options="ufs"
                          v-model="property.uf"
                          @blur.native="
                            clearInvalidFields('uf', 'invalidFieldsProperty')
                          "
                        >
                        </b-form-select>
                      </div>
                      <div class="input-group" style="width: 100%">
                        <input
                          required
                          class="input borderInput"
                          v-model="property.ibge"
                        />
                        <label class="user-label"> Código IBGE </label>
                      </div>
                    </div>
                  </div>
                  <div class="rowContent">
                    <div class="input-group" style="width: 100%">
                      <input
                        required
                        class="input borderInput"
                        v-mask="maskTelefone"
                        v-model="property.telefone"
                      />
                      <label class="user-label"> Telefone </label>
                    </div>
                    <div class="input-group" style="width: 100%">
                      <input
                        required
                        class="input borderInput"
                        v-model="property.celular"
                        v-mask="maskCelular"
                      />
                      <label class="user-label"> Whatsapp </label>
                      <div class="iconSelect">
                        <div role="button">
                          <img
                            class="whatsapp"
                            :src="whatsapp"
                            @click="redirectWhatsApp(property.celular)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="input-group" style="width: 100%">
                      <input
                        required
                        class="input borderInput"
                        v-model="property.email"
                      />
                      <label class="user-label"> Email </label>
                    </div>
                  </div>
                </div>
              </b-row>

              <div class="property-actions">
                <b-button
                  class="btnsSaveNeutralProperty"
                  @click="clearCustomerPropertyInputs"
                  >Novo</b-button
                >
                <b-button
                  class="btnsSaveProperty"
                  @click="saveOrUpdateProperty"
                >
                  {{
                    property.id
                      ? "Atualizar propriedade"
                      : "Adicionar propriedade"
                  }}
                </b-button>
              </div>

              <div class="talhao-panel">
                <div class="property-section-title">
                  <b-icon-grid3x3-gap-fill /> Inserção de talhões
                </div>
                <b-alert
                  v-if="!property.id"
                  show
                  variant="light"
                  class="small mb-0"
                >
                  Salve ou selecione uma propriedade para cadastrar seus
                  talhões.
                </b-alert>
                <template v-else>
                  <b-row>
                    <div class="rowContainer" style="width: 100%">
                      <div class="rowContent">
                        <div class="input-group" style="width: 100%">
                          <input
                            required
                            class="input borderInput"
                            :class="
                              invalidFieldsTalhao?.nome && 'isInvalidInput'
                            "
                            v-model="talhao.nome"
                          />
                          <label class="user-label"> Nome do Talhão * </label>
                        </div>
                      </div>
                      <div class="rowContent">
                        <div class="input-group">
                          <input
                            required
                            class="input borderInput"
                            v-model="talhao.cultura"
                          />
                          <label class="user-label"> Cultura </label>
                        </div>
                        <div class="input-group">
                          <input
                            required
                            class="input borderInput"
                            v-model="talhao.latitude"
                          />
                          <label class="user-label"> Latitude </label>
                        </div>
                        <div class="input-group">
                          <input
                            required
                            class="input borderInput"
                            v-model="talhao.longitudade"
                          />
                          <label class="user-label"> Longitude </label>
                        </div>
                      </div>
                      <div class="rowContent">
                        <div class="input-group" style="width: 100%">
                          <input
                            required
                            class="input borderInput"
                            v-model="talhao.observacao"
                          />
                          <label class="user-label"> Observação </label>
                        </div>
                      </div>
                    </div>
                  </b-row>
                  <div class="property-actions">
                    <b-button
                      size="sm"
                      class="btnsSaveNeutralProperty"
                      @click="clearTalhaoInputs"
                      >Novo</b-button
                    >
                    <b-button
                      size="sm"
                      class="btnsSaveProperty"
                      @click="saveOrUpdateTalhao"
                      >{{
                        talhao.id ? "Atualizar talhão" : "Adicionar talhão"
                      }}</b-button
                    >
                  </div>
                  <div class="talhao-list">
                    <button
                      v-for="item in talhoes"
                      :key="item.id"
                      type="button"
                      class="talhao-item"
                      @click="findTalhao(item.id)"
                    >
                      <span
                        ><strong>Nome: {{ item.nome }}</strong
                        ><small>
                          Cultura:
                          {{ item.cultura || "Sem cultura informada" }}</small
                        ></span
                      >
                      <b-icon-trash-fill
                        class="text-danger"
                        @click.stop="getTalhaoIdToDelete(item.id)"
                      />
                    </button>
                    <small v-if="!talhoes.length" class="text-muted"
                      >Nenhum talhão cadastrado.</small
                    >
                  </div>
                </template>
              </div>
            </section>
          </b-col>

          <b-col cols="12" md="6" lg="6">
            <div class="carroselCtn">
              <div class="mapsTab">
                <label
                style="margin-bottom: 0px !important;"
                  v-for="item in tobs"
                  :key="item.text"
                  class="mapsTabItem"
                  :class="{
                    active: selectedMap === item.value,
                  }"
                  @click="storeMapName(item.text)"
                >
                  {{ item.text }} <br />
                </label>
              </div>
            </div>
            <div
              v-if="selectedMap === 'Propriedade'"
              style="display: flex; flex-direction: column"
            >
              <PropertyMap
                ref="propertyMap"
                :active="selectedLabel === 'Propriedades'"
                :latitude="property.latitude"
                :longitude="property.longitude"
                :marker-coordinates="propertyMarkerCoords"
                @location-selected="applyGeocodedLocation"
              />
            </div>
            <div
              v-if="selectedMap === 'Talhão'"
              style="display: flex; flex-direction: column"
            >
              <TalhaoMap
                :active="selectedLabel === 'Propriedades'"
                :latitude="talhao.latitude"
                :longitude="talhao.longitudade"
                :property-latitude="property.latitude"
                :property-longitude="property.longitude"
                @location-selected="applyTalhaoLocation"
              />
            </div>
          </b-col>
        </b-row>

        <section class="properties-footer">
          <div class="property-section-title">
            <b-icon-list-ul /> Propriedades cadastradas
            <b-badge variant="success">{{ customerProperties.length }}</b-badge>
          </div>
          <div class="table-responsive">
            <b-table
              v-if="customerProperties.length"
              hover
              small
              responsive
              :items="customerProperties"
              :fields="[
                { key: 'nome', label: 'Nome' },
                { key: 'cpfCnpj', label: 'CPF/CNPJ' },
                { key: 'endereco', label: 'Endereço' },
                { key: 'cidade', label: 'Cidade' },
                { key: 'actions', label: '', class: 'text-right' },
              ]"
              @row-clicked="selectPropertyRow"
            >
              <template #cell(endereco)="data">{{
                data.item.endereco || "--"
              }}</template>
              <template #cell(cidade)="data">{{
                data.item.cidade || "--"
              }}</template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  variant="link"
                  class="text-danger"
                  @click.stop="getPropertyIdToDelete(data.item.id)"
                >
                  <b-icon-trash-fill />
                </b-button>
              </template>
            </b-table>
            <b-alert v-else show variant="light" class="mb-0"
              >Nenhuma propriedade cadastrada para este cliente.</b-alert
            >
          </div>
        </section>
      </div>
    </div>

    <ModalConfirm
      modalName="confirmDeleteProperty"
      title="Excluir item"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="deleteProperty"
    />

    <ModalConfirm
      modalName="confirmDeleteTalhao"
      title="Excluir talhão"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="deleteTalhao"
    />

    <ModalConfirm
      typeModal="info"
      modalName="verifyProperty"
      title="Propriedade não vinculada!"
      subtitle="Este cliente não possui propriedade cadastrada. Deseja criar uma nova utilizando o endereço informado ?"
      headerIcon="b-icon-patch-exclamation-fill"
      rightButtonText="Não"
      leftButtonText="Sim, utilizar!"
      :leftButtonClick="assingCustomerAddressToProperties"
    />
  </b-card>
</template>

<script>
import mixinCustomer from "../../mixins/Customer/Customer";

export default {
  mixins: [mixinCustomer],
};
</script>
<style scoped>
.property-tab {
  display: block;
  padding-top: 1px;
}
.property-workspace {
  align-items: stretch;
}
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col,
.col-auto,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm,
.col-sm-auto,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md,
.col-md-auto,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg,
.col-lg-auto,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 5px;
  padding-left: 5px;
}
.property-form-panel,
.properties-footer {
  border: 1px solid #e2e8e6;
  border-radius: 10px;
  background: #fff;
  padding: 5px 16px 16px 16px;
}
.property-form-panel {
  height: 100%;
}
.properties-footer {
  width: 100%;
  margin: 18px 0;
}
.property-section-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  color: #006256;
  font-size: 14px;
  font-weight: 700;
}
.property-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.talhao-panel {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}
.talhao-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
}
.talhao-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px;
  border: 1px solid #e4e9e7;
  border-left: 4px solid #198754;
  border-radius: 5px;
  background: #fafcfb;
  color: #3a4750;
  text-align: left;
}
.talhao-item span {
  width: 80%;
  justify-content: space-between;
  display: flex;
}
.talhao-item small {
  font-weight: 400;
}
.properties-footer ::v-deep tbody tr {
  cursor: pointer;
}
.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.carroselCtn {
  display: flex;
  gap: 10px;
}

.StatementOnAccount {
  display: flex;
  align-items: flex-end;
  height: 55px;
  width: 100%;
  gap: 1px;
  overflow: scroll;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: transform 0.5s ease-in-out;
}

.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 10px;
  background: #cdcdcd;
  color: #000000;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  height: 35px;
  background-color: #006458;
  color: white;
  border-bottom: 2px solid white;
  padding-bottom: 5px;
  border-radius: 10px 10px 0 0;
  transform: translateY(-4px);
}

.StatementOnAccountItem:hover {
  background-color: #006458;
  color: white;
}

.StatementOnAccountItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.tabDisabled {
  pointer-events: none;
  background-color: #f5f5f5;
  color: #c0c0c0;
  user-select: none;
}

.carroselCtn {
  display: flex;
  gap: 10px;
}

.mapsTab {
  display: flex;
  align-items: flex-end;
  height: 42px;
  width: 100%;
  gap: 1px;
  overflow: scroll;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: transform 0.5s ease-in-out;
}

.mapsTab ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.mapsTab::-webkit-scrollbar-track {
  background: white;
}

.mapsTab::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.mapsTabItem {
  height: 25px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 20px;
  background: #cdcdcd;
  color: #000000;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.mapsTabItem p {
  font-weight: 600;
 }

.mapsTabItem.active {
  height: 27px;
  background-color: #006064;
  color: white;
  border-bottom: 1px solid white;
  padding-bottom: 0px;
  border-radius: 5px 5px 0 0;
  transform: translateY(-2px);
}

.mapsTabItem:hover {
  background-color: #006458;
  color: white;
}

.mapsTabItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.isInvalidInput {
  transition: ease-in all 0.1s !important;
  box-shadow: 0 0 0 1.5px rgba(204, 21, 21, 0.583) !important;
}

.invalidLabel {
  color: rgba(142, 15, 15, 0.583);
}

.ContentTable {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  max-width: 100%;
}

.rowSupplier {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  height: 40px;
  gap: 20px;
  padding: 2px 20px;
  cursor: context-menu;
  font-size: 12px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.207);
  justify-content: space-between;
  cursor: pointer;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
  cursor: pointer;
}

.celTableActions {
  display: flex;
  gap: 10px;
  height: 50px;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(131 130 130);
  border-radius: 5px;
  height: 25px;
  width: 25px;
  font-size: 10px !important;
  font-weight: 100 !important;
  padding: 5px 10px;
  color: whitesmoke;
  cursor: pointer;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: rgb(213, 213, 213);
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: context-menu;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.validRed {
  font-size: 13px;
  color: red;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.validRed::before {
  color: blue;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 10px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.requiredFields {
  font-size: 11px;
  color: red;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 5px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.btnsSave {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
  font-weight: 600;
  position: relative;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 165px;
  border: none;
  margin-top: 30px;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveProperty {
  border-radius: 5px;
  background-color: #006256;
  width: auto;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveNeutralProperty {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: auto;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.input-group {
  width: 30%;
}

.input-group-ob {
  width: 65%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .input-group {
    width: 100%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
}
</style>
